module.exports = __webpack_public_path__ + "img/661f4ad.svg";